/**
 * Anonymous visitor ID — persisted in cookie + localStorage.
 * SSR-safe: returns "" when not in browser.
 */
const KEY = "tw_aid";
const COOKIE_MAX_AGE = 60 * 60 * 24 * 365; // 1 year

function uuid(): string {
  if (typeof crypto !== "undefined" && "randomUUID" in crypto) {
    return crypto.randomUUID();
  }
  return "aid_" + Math.random().toString(36).slice(2) + Date.now().toString(36);
}

function readCookie(name: string): string {
  if (typeof document === "undefined") return "";
  const m = document.cookie.match(new RegExp("(?:^|; )" + name + "=([^;]*)"));
  return m ? decodeURIComponent(m[1]) : "";
}

function writeCookie(name: string, value: string) {
  if (typeof document === "undefined") return;
  const secure = window.location.protocol === "https:" ? "; Secure" : "";
  document.cookie = `${name}=${encodeURIComponent(value)}; Max-Age=${COOKIE_MAX_AGE}; Path=/; SameSite=Lax${secure}`;
}

/**
 * Adopt an existing anonymous id (used when a recognised device turns out to
 * have shopped here before under a different locally-stored id).
 */
export function setAnonymousId(id: string): void {
  if (typeof window === "undefined" || !id) return;
  try {
    localStorage.setItem(KEY, id);
  } catch {
    /* private mode */
  }
  writeCookie(KEY, id);
}

export function getAnonymousId(): string {
  if (typeof window === "undefined") return "";
  let id = "";
  try {
    id = localStorage.getItem(KEY) || "";
  } catch {
    /* private mode */
  }
  if (!id) id = readCookie(KEY);
  if (!id) id = uuid();
  try {
    localStorage.setItem(KEY, id);
  } catch {
    /* ignore */
  }
  writeCookie(KEY, id);
  return id;
}
